import { AppModule } from '@/config/types'
import type { RouteRecordRaw } from 'vue-router'

export const consentRouteName = 'user.consent'

export const getConsentRoutes = (): RouteRecordRaw[] => [
  {
    name: `${consentRouteName}.base`,
    path: 'consent',
    component: () => import('@/components/containers/CleanPageContainer.vue'),
    children: [
      {
        name: consentRouteName,
        path: '',
        component: () => import('@/components/views/consent/ConsentPage.vue'),
        meta: {
          tabTitle: 'pageTabTitle.consent',
          modules: [AppModule.Consent],
          resolverComponent: () => import('@/components/domain/consent/ConsentPageResolver.vue'),
          resolvers: [
            {
              service: 'ConsentAppResolverService',
            },
          ],
        },
      },
    ],
  },
]
